var ErrorSources;
(function (ErrorSources) {
    ErrorSources["Table"] = "table";
    ErrorSources["Row"] = "row";
})(ErrorSources || (ErrorSources = {}));

export { ErrorSources };
